import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/abonoInicial';

const fetchAbono = createAction('fetchAbono');

function fetchAbonoSuccess(state, action) {
  const { data } = action.payload;
  state.data = data;
  state.successFetching = true;
  state.errorFetching = false;
}

function fetchAbonoError(state) {
  state.data = {};
  state.successFetching = false;
  state.errorFetching = true;
}

const abonoReducer = createSlice({
  name: 'abono',
  initialState,
  reducers: {
    fetchAbonoSuccess,
    fetchAbonoError,
  },
});

export const abonoActions = {
  ...abonoReducer.actions,
  fetchAbono,
};

export default abonoReducer.reducer;
